module.exports = __webpack_public_path__ + "static/media/ic-arrow-up-green.7dca76f0.svg";